function deplacer_projet_doc(id,id_parent) {
    $.ajax({
        url: 'inc/xhr/actions.php?action=deplacer_projet_doc&id='+id+'&id_parent='+id_parent,
        success: function(data){
            window.location.reload();
        }
    });
}

function pop_in_video(id){
    $.ajax({
        url: 'inc/xhr/actions.php?action=pop_in_video&id='+id,
        success: function(data){
            ouvre_popinnoir(data);
        }
    });
}

function pop_in_video_publi(id){
    $.ajax({
        url: 'inc/xhr/actions.php?action=pop_in_video_publi&id='+id,
        success: function(data){
            ouvre_popinnoir(data);
        }
    });
}

function fermer_question(){
    $('#questiondiv').animate({ left:'-100%'}, 'fast');
}

function envoyer_question(){
    if(!valide_mail($('#emailquestion').val()))
        alert("merci de saisir une adresse mail valide");
    else if($('#textequestion').val()=="")
        alert("votre message est vide !");
    else if($('#testquestion').val()=="")
        $('#formquestion').submit();
}

function verif_submit_commentaires(){
    var erreur = 0;
    if ($("#nom").val() == ""){
        alert("Vous devez renseigner un nom ou un pseudonyme !");
        erreur=1;
    }
    if ($("#message").val() == ""){
        alert("Votre message est vide !");
        erreur=1;
    }
    if ($("#test").val() != "16"){
        alert("Erreur du test anti soumission automatique ! ");
        erreur=1;
    }
    if (erreur==0)
        $("#formcommentaire").submit();
}

var timeout    = 200;
var closetimer = 0;
var ddmenuitem = 0;
function MenuDeroulant_open(){
    MenuDeroulant_canceltimer();
    MenuDeroulant_close();
    ddmenuitem = $(this).find('.sousmenuH').css('visibility', 'visible');
}
function MenuDeroulant_close(){
    if(ddmenuitem)
        ddmenuitem.css('visibility', 'hidden');
}
function MenuDeroulant_timer(){
    closetimer = window.setTimeout(MenuDeroulant_close, timeout);
}
function MenuDeroulant_canceltimer(){
    if (closetimer){
        window.clearTimeout(closetimer);
        closetimer = null;
    }
}
function ThisMenuDeroulant_open(name){
    ddmenuitem = $('#'+name).css('visibility', 'visible');
}

function afficher_recherche(site){
    $('html, body').delay(200).animate({scrollTop:0}, 'fast');
    $.ajax({
        url: 'inc/xhr/actions.php?action=recherche&site='+site,
        success: function(data){
            ouvre_popinnoir(data);
        }
    });
}

function fermer_popin(){
    $("#popin .container").html("");
    $("#popin").hide();
    $("#contpopinnoir").html("");
    $("#popinnoir").hide();
    $("#minipopin .container").html("");
    $("#minipopin").hide();
}

function ouvre_popinnoir(data){
    var posScroll = parseInt($(document).scrollTop());
    var popin_content = "<div style=\"height: "+posScroll+"px;width:100%\"></div><div style=\"float:right;\"><a class=\"fermer\" href=\"javascript:fermer_popin()\"><img src=\"images/env/b_fermer.png\" border=\"0\" \></a></div><div style=\"padding-top: 0px;\"> " + data + "</div>";
    $("#contpopinnoir").html(popin_content); // ON AFFICHE LA REPONSE
    $("#contpopinnoir").css("height",$("body").height()+"px");
    $("#popinnoir").show();
}

function ouvre_popin(data){
    // var popin_content = "<div style=\"float:right\"><a class=\"bouton2\" href=\"javascript:fermer_popin()\">X</a></div><div style=\"clear:both; \"> " + data + "</div>";
    // $("#popin .container").html(popin_content); // ON AFFICHE LA REPONSE
    $("#popin .container").html(data); // ON AFFICHE LA REPONSE
    $("#popin").show();

    var left = ($(window).width() - $("#popin").width())/2;
    var posScroll = parseInt($(document).scrollTop());

    $("#popin").css('top',(posScroll+150)+'px');
    $("#popin").css('left',left+'px');

    $('.tableauborder tbody').each(function(){
        $('tr:has(td):odd', this).addClass('trgris');
    });
}


function ouvre_minipopin(data){
    // var popin_content = "<div style=\"float:right\"><a class=\"bouton2\" href=\"javascript:fermer_popin()\">X</a></div><div style=\"clear:both; \"> " + data + "</div>";
    // $("#popin .container").html(popin_content); // ON AFFICHE LA REPONSE
    $("#minipopin .container").html(data); // ON AFFICHE LA REPONSE
    $("#minipopin").show();

    // var left = ($(window).width() - $("#minipopin").width())/2;
    // var posScroll = parseInt($(document).scrollTop());

    // $("#minipopin").css('top',(posScroll+150)+'px');
    // $("#minipopin").css('left',left+'px');
}

function ouvre_popin_responsive(data){
    $("#popin .container").html(data); // ON AFFICHE LA REPONSE
    $("#popin").show();

    var left = ($(window).width() - $("#popin").width())/2;
    var posScroll = parseInt($(document).scrollTop());

    $("#popin").css('top',(posScroll+150)+'px');
}

var recherche_ouverte = false;
function rechercher(){
    if (!recherche_ouverte){
        recherche_ouverte = true;
        $("#chercher a").css("background-position","0 -128px");
        $("#formchercher input").show();
        $("#formchercher input").animate({width: 107}, 400);
        $("#menuhaut #menurub").animate({marginLeft: 283}, 400);
        $(".bandeau_nav").each(function (){
            $("div",this).css("margin-left","270px");
        });
    }
    else
        $("#formchercher").submit();
}

function ouvrefiche(i,couleur){
    var posY = new Array();
    posY[2] = 0;
    posY[3] = -25;
    posY[5] = -50;
    if($("#infoscomp"+i).css("display") == "none")
        $("#aplusdinfos"+i).css("background-position",posY[couleur]+"px -25px");
    else
        $("#aplusdinfos"+i).css("background-position",posY[couleur]+"px 0");
    $("#infoscomp"+i).slideToggle();
}

function form_commentaire(){
    $("#formcommentaire").slideToggle(150);
}

function form_ml_accueil(){
    $("#formulaireml").slideToggle(150);
}

function test_lien(){
    if (navigator.appName=="Microsoft Internet Explorer" || navigator.appName=="Netscape"){
        document.links[0].blur();
    }
}

function formulaire_inscription(id){
    $(".form_inscription").html("");
    $(".form_inscription").hide();
    $.ajax({
        url: 'inc/xhr/actions.php?action=formulaire_inscription&id='+id,
        success: function(data){
            $("#form_inscription"+id).html(data);
            $("#form_inscription"+id).show();
        }
    });
}

function fermer_inscription(id) {
    $("#form_inscription"+id).hide();
    $("#form_inscription"+id).html("");
}

function fermer_adhesion() {
    $("#form_adhesion").hide();
    $("#form_adhesion").html("");
    $("#bouton_afficher_forumlaire").removeClass("masque");
}

function ouvre_paragraphe(id){
    $("#intro"+id).slideToggle();
    $("#parag"+id).slideToggle();
    classlien = $("#lienparag"+id).attr("class");
    if(classlien=="lienplusparag")
        $("#lienparag"+id).attr("class","lienmoinsparag");
    else
        $("#lienparag"+id).attr("class","lienplusparag");
    $(".fiche_ecole .tabnom .tdh4").each(function (){
        $(this).removeAttr("width");
        width = $('h4',this).width()+10;
        $(this).attr("width",width);
    });
}

function test_nouveau_item(value,menu_name,form_name,message,etiquette){
    if(value==-1){
        result = prompt(message, '');
        if (result != null && result != ""){
            combien = document.forms[form_name].elements[menu_name].length;
            nouveau = new Option(etiquette,-1,false,false);
            ajout = new Option(result,result,true,true);
            document.forms[form_name].elements[menu_name].options[combien] = nouveau;
            document.forms[form_name].elements[menu_name].options[combien-1] = ajout;
        }
    }
}

var departdiapo = new Array();
var attendre = new Array();
function lancer_diaporama(id_diaporama,nb_photo){
    if (typeof(departdiapo[id_diaporama]) == 'undefined'){
        departdiapo[id_diaporama]=1;
        attendre[id_diaporama] = 1;
    }
    //alert(nombre_photo + "'" + photo_charges.length + "'");

    if (attendre[id_diaporama]==1 && nb_photo+1 == photo_charges[id_diaporama].length){
        attendre[id_diaporama] = 0;
    }

    if (attendre[id_diaporama]==0){
        encour = departdiapo[id_diaporama];

        if(departdiapo[id_diaporama]<nb_photo)
            departdiapo[id_diaporama]++;
        else
            departdiapo[id_diaporama]=1;

        divencour=document.getElementById('photodiapo'+id_diaporama+encour);
        divencour.style.display='none';
        divencour=document.getElementById('photodiapo'+id_diaporama+departdiapo[id_diaporama]);
        divencour.style.display='';
    }

    theTimer=setTimeout("lancer_diaporama("+id_diaporama+","+nb_photo+")",3000);
}

function ouvre_ferme_menu(i){
    var divo=document.getElementById("menu"+i+"ouvert");
    var divf=document.getElementById("menu"+i+"ferme");

    if (divo.style.display=='none'){
        divo.style.display='block';
        divf.style.display='none';
    }
    else{
        divo.style.display='none';
        divf.style.display='block';
    }
}

function affiche_1div(num,nbre,div_prefixe){
    for(i=1;i<=nbre;i++){
        if (i==num) {
            //alert("#"+div_prefixe+i);
            $("#"+div_prefixe+i).css("display",'block');
        }
        else
            $("#"+div_prefixe+i).css("display",'none');
    }
}

function moins(input,tranche){
    actuel = 1*$('#'+input).val();
    if (actuel>tranche)
        $('#'+input).val(eval(actuel-tranche));
    else
        alert('quantite minimum atteinte !');
}

function plus(input,maxi,tranche){
    actuel = 1*$('#'+input).val();
    if(maxi == '' || (actuel+tranche)<=maxi)
        $('#'+input).val(eval(actuel+tranche));
    else
        alert('quantite maximum atteinte !');
}

function affiche_div(div_name){
    $('#'+div_name).show();
}

function ouvre_div(div_name){
    $('#'+div_name).slideDown('fast');
}

function ferme_div(div_name){
    $('#'+div_name).slideUp('fast');
}

function masque_div(div_name){
    $('#'+div_name).hide();
}

function affiche_masque_div(div_name,value){
    var ma_div=document.getElementById(div_name);
    ma_div.style.display=(value==1) ? 'block' : 'none';
}

function MM_displayStatusMsg(msgStr){ //v1.0
  status=msgStr;
  document.MM_returnValue = true;
}

function MM_preloadImages(){ //v3.0
        var d=document; if(d.images){ if(!d.MM_p) d.MM_p=new Array();
    var i,j=d.MM_p.length,a=MM_preloadImages.arguments; for(i=0; i<a.length; i++)
    if (a[i].indexOf("#")!=0){ d.MM_p[j]=new Image; d.MM_p[j++].src=a[i];}}
}

function MM_swapImgRestore(){ //v3.0
        var i,x,a=document.MM_sr; for(i=0;a&&i<a.length&&(x=a[i])&&x.oSrc;i++) x.src=x.oSrc;
}

function MM_findObj(n, d){ //v4.01
    var p,i,x;  if(!d) d=document; if((p=n.indexOf("?"))>0&&parent.frames.length){
        d=parent.frames[n.substring(p+1)].document; n=n.substring(0,p);}
    if(!(x=d[n])&&d.all) x=d.all[n]; for (i=0;!x&&i<d.forms.length;i++) x=d.forms[i][n];
    for(i=0;!x&&d.layers&&i<d.layers.length;i++) x=MM_findObj(n,d.layers[i].document);
    if(!x && d.getElementById) x=d.getElementById(n); return x;
}

function MM_swapImage(){ //v3.0
        var i,j=0,x,a=MM_swapImage.arguments; document.MM_sr=new Array; for(i=0;i<(a.length-2);i+=3)
        if ((x=MM_findObj(a[i]))!=null){document.MM_sr[j++]=x; if(!x.oSrc) x.oSrc=x.src; x.src=a[i+2];}
}

function MM_jumpMenu(targ,selObj,restore){ //v3.0
  eval(targ+".location='"+selObj.options[selObj.selectedIndex].value+"'");
  if (restore) selObj.selectedIndex=0;
}

